import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

import { ContactsEmptyState } from '../components/contactsEmptyState/contactsEmptyState';

export const noContactSelected = (
  <ContactsEmptyState
    title="No contact selected"
    description="Please select a contact from the sidebar to view its details."
    icon="user"
  />
);

export const noCompanySelected = (
  <ContactsEmptyState
    title="No company selected"
    description="Please select a company from the sidebar to view its details."
    icon="building"
  />
);

export const contactNotFound = (
  <ContactsEmptyState
    title="User not found"
    description="We were not able to the find the contact you are looking for. Try using the search in the sidebar."
  />
);

export const contactLoadFailed = (
  <ContactsEmptyState
    title="Something went wrong"
    description="An error occurred while getting contact details."
  />
);

export const contactLoading = (
  <FlexBox
    alignItems="center"
    justifyContent="center"
    height="100%"
    width="100%"
  >
    <Spinner />
  </FlexBox>
);
